import type { GatsbyBrowser } from 'gatsby';
import * as React from 'react';
import './src/styles/Global.css';
import './src/styles/TailwindStyles.css';
import MainTemplate from './src/templates/MainTemplate';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = (props) => (
  <MainTemplate {...props} />
);
